import React, { useState } from 'react';
import './Home.css';
import { Parallax } from 'react-parallax';
import bannerImage from "../src/Assets/probg.jpg";
import visitor from "../src/Assets/visitorapp.png";
import neo from "../src/Assets/NEO_new2.png";
import policyack from "../src/Assets/policyack2.png";
import visitorpdf from "../src/Assets/G5_Visitor_App.pdf";
import neopdf from "../src/Assets/NEO_Identity.pdf";
import policyackpdf from "../src/Assets/PolicyAck.pdf";
import grctool from "../src/Assets/GRC.png";
// import servicebg1 from "../src/Assets/tree3.png";
import badge50 from "../src/Assets/50.png";
import badge40 from "../src/Assets/40.png";
import hat from "../src/Assets/hat.png";


function Home() {
  const [showModal, setShowModal] = useState(false);
  const [modalPDF, setModalPDF] = useState(null);

  const openModal = (pdf) => {
    setModalPDF(pdf);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalPDF(null);
  };

  return (
    <div className="home-main">
      <img src='tree3.png' alt="Background" className="background-image" />
      <div className="banner-content">
        <div className="title-wrapper">
          {/* --- Holiday Offer Image Commented --- */}
          {/* <img src={hat} alt="Holiday Hat" className="hat-image" /> */}
          <h1 className="banner-text">Golden Five Products</h1>
        </div>
        <p className="banner-subtext">
          Here are our products which are available to purchase. We can customize them according to your infrastructure requirements.
        </p>
      </div>


      <div className="products-section">
        <h2 className="products-title">Our Products</h2>

        {/* --- Product 1: NEO --- */}
        <div className="product-card">
          {/* --- Offer Badge Commented --- */}
          {/* <img src={badge40} alt="40% badge" className="offer-badge-img" /> */}
          <img src={neo} alt="Golden Five NEO" className="product-image" />
          <div className="product-content">

            {/* --- Holiday Offer Logic Commented --- */}
            {/* <h2 className="offer-head">Holiday Offer</h2> */}
            <h3>Golden Five NEO - NEW EMPLOYEE ONBOARDING SOFTWARE</h3>
            <p>
              NEO software tackles the issue of automated user provisioning and access management. Whenever there is a change in the HR system (e.g., new employee, name change, role change, leaving employment), our solutions trigger the appropriate process automatically.
            </p>
            {/* Example of showing actual price if known, otherwise use purchase button */}
            {/* <p className="actual-price">Price: $15,000.00</p> */}
            <p className="learn" onClick={() => openModal(neopdf)}>Learn more</p>
            <button
              className="more-button"
              onClick={() => window.open("https://forms.office.com/r/t1uVCwKtMd", "_blank")}
            >
              Purchase Now
            </button>
          </div>
        </div>

        {/* --- Product 2: PolicyAck --- */}
        <div className="product-card">
          {/* --- Offer Badge Commented --- */}
          {/* <img src={badge40} alt="40% badge" className="offer-badge-img" /> */}

          <img src={policyack} alt="PolicyAck" className="product-image" />
          <div className="product-content">
            {/* --- Holiday Offer Logic Commented --- */}
            {/* <h2 className="offer-head">Holiday Offer</h2> */}

            <h3>PolicyAck - ONE SOLUTION FOR POLICY MANAGEMENT</h3>
            <p>
              PolicyAck is a modern solution designed to address inefficiencies in policy management by automating workflows and ensuring compliance. It replaces outdated tools like spreadsheets and Word files, offering seamless integration with Microsoft 365.
            </p>
            <p className="learn" onClick={() => openModal(policyackpdf)}>Learn more</p>
            <button
              className="more-button"
              onClick={() => window.open("https://forms.office.com/r/t1uVCwKtMd", "_blank")}
            >
              Purchase Now
            </button>
          </div>
        </div>

        {/* --- Product 3: Visitor Log --- */}
        <div className="product-card">
          {/* --- Offer Badge Commented --- */}
          {/* <img src={badge40} alt="40% badge" className="offer-badge-img" /> */}

          <img src={visitor} alt="System Admin Tool" className="product-image" />
          <div className="product-content">
            {/* --- Holiday Offer Logic Commented --- */}
            {/* <h2 className="offer-head">Holiday Offer</h2> */}

            <h3>VISITOR LOG</h3>
            <p>
              Visitor App revolutionizes the way you manage visitors, offering a seamless, secure, and professional check-in experience. Designed for efficiency, this app ensures a smooth process for both visitors and your organization.
            </p>
            <p className="learn" onClick={() => openModal(visitorpdf)}>Learn more</p>
            <button
              className="more-button"
              onClick={() => window.open("https://forms.office.com/r/t1uVCwKtMd", "_blank")}
            >
              Purchase Now
            </button>


          </div>
        </div>

        {/* --- Product 4: GRC Tool --- */}
        <div className="product-card">
          {/* --- Offer Badge Commented --- */}
          {/* <img src={badge40} alt="40% badge" className="offer-badge-img" /> */}

          <img src={grctool} alt="GRC Tool" className="product-image" />
          <div className="product-content">
            {/* --- Holiday Offer Logic Commented --- */}
            {/* <h2 className="offer-head">Holiday Offer</h2> */}

            <h3>GRC Tool</h3>
            <p>
              The GRC Tool is a comprehensive solution designed to streamline governance, risk management, and compliance processes within an organization. It offers a centralized platform to manage policies, assess risks, and ensure regulatory compliance effectively.
            </p>
            <p className="learn" onClick={() => openModal()}>Learn more</p>
            <button
              className="more-button"
              onClick={() => window.open("https://forms.office.com/r/t1uVCwKtMd", "_blank")}
            >
              Purchase Now
            </button>
          </div>
        </div>

        {showModal && modalPDF && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>×</button>
              <iframe src={modalPDF} title="PDF Preview" width="100%" height="500px" />
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Home;